// Talks to the real Rajiv Syndicate backend (mainSite/server) — the same
// backend the existing admin panel (admin.html) edits. See
// docs/PROJECT-DOCUMENTATION.md in mainSite/ for the content model.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

export async function getSiteData() {
  const res = await fetch(`${BACKEND_URL}/api/site-data`);
  if (!res.ok) throw new Error("Failed to load site content");
  return res.json();
}

export async function submitContact({ name, email, phone, message }) {
  const res = await fetch(`${BACKEND_URL}/api/contact`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ name, email, phone, message }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || !data.ok) throw new Error(data.error || "Failed to send enquiry");
  return data;
}

export async function submitCareer(fields, resumeFile) {
  const fd = new FormData();
  Object.entries(fields).forEach(([k, v]) => fd.append(k, v ?? ""));
  if (resumeFile) fd.append("resume", resumeFile);
  const res = await fetch(`${BACKEND_URL}/api/career`, { method: "POST", body: fd });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || !data.ok) throw new Error(data.error || "Failed to submit application");
  return data;
}

// Content image paths come back as either a relative path (e.g.
// "images/sanjay-jain.jpg", served by the backend itself) or null (nothing
// uploaded yet — caller should fall back to a stock photo). Never a
// same-origin-relative React asset — always resolve against the backend.
export function resolveImage(path, fallback) {
  if (!path) return fallback;
  if (/^https?:\/\//i.test(path)) return path;
  return `${BACKEND_URL}/${path.replace(/^\/+/, "")}`;
}

// Looks up one entry from the `images` collection by its catalog id.
export function findImage(images, id) {
  return (images || []).find((im) => im.id === id) || null;
}
